module.exports = __webpack_public_path__ + "img/head-mv2-04.689f7425.jpg";